// extracted by mini-css-extract-plugin
export default {"textP":"TextP_textP__Br8Gw","shrinked":"TextP_shrinked__Ltj6+","c1Paragraph":"TextP_c1Paragraph__WCySw"};